import { useContext } from 'react';
import Skeleton from '@mui/material/Skeleton';
import { Helmet } from 'react-helmet-async';
import { FolderLoadingContext, FolderStateContext } from '@/containers/Workspace.Folder/Context';
import { FolderBreadcrumbs } from '@/screens/Workspace.Folder/Header.Breadcrumbs';
import styles from '@/screens/Workspace.File/style/Header.module.css';
import { Actions } from './Header.Actions';
/* import { Actions } from './Header.Actions'; */

export const Header = () => {

  return (
    <div className={styles.root}>
      <div className={styles.wrap}>
        <div className={styles.main}>

          <FolderBreadcrumbs />

          <div className={styles.details}>
            <div className={styles.info}>

              <div className={styles.header}>
                <Title />
              </div>

            </div>

            <Actions />
          </div>

          <div className={styles.subtitle}>

          </div>

        </div>
      </div>
    </div>
  );
};

const Title = (props: unknown) => {
  const isLoading = useContext(FolderLoadingContext);
  const folderCtx = useContext(FolderStateContext);

  if (isLoading) {
    return (
      <Skeleton
        style={{ marginRight: 10 }}
        height={30}
        width={400}
        variant="rectangular" />
    );
  }

  return (
    <>
      <Helmet title={folderCtx.folder.name} />
      <h1 className={styles.title}>{folderCtx.folder.name}</h1>
    </>
  );
};

Title.displayName = 'Folder.Header.Title';